// Bilingual content for ALEGER × RuggedEdge homepage
// Texts are VERBATIM from the user spec. Do not paraphrase.

export const translations = {
  de: {
    meta: {
      title: "ATEX 5G Edge Gateway für Industrie | ALEGER GLOBAL",
      description:
        "EdgeOne von RuggedEdge verbindet Mitarbeiter, Sensoren, Maschinen und Experten in rauen und explosionsgefährdeten Industrieumgebungen. ALEGER GLOBAL unterstützt Remote Assist, Private 5G, IoT-Daten, Connected Worker Safety und Edge AI von der Beratung bis zum Pilotprojekt.",
    },
    nav: {
      problem: "Problem",
      solution: "Lösung",
      platform: "Plattform",
      useCases: "Use Cases",
      industries: "Branchen",
      pilot: "Pilotprojekt",
      specs: "Technische Daten",
      whyAleger: "Warum ALEGER",
      faq: "FAQ",
      contact: "Kontakt",
      ctaPrimary: "Pilotprojekt anfragen",
      ctaSecondary: "Use Cases ansehen",
    },
    hero: {
      eyebrow: "ALEGER × RUGGEDEDGE — ATEX 5G EDGE GATEWAY",
      h1: "ATEX 5G Edge Gateway für Industrie, Remote Assist und IoT-Daten",
      sub:
        "Mit EdgeOne von RuggedEdge verbindet ALEGER GLOBAL Mitarbeiter, Sensoren, Maschinen und Experten in rauen und explosionsgefährdeten Industrieumgebungen.",
      text:
        "EdgeOne kombiniert Public und Private 5G, Wi-Fi 6/6E, Bluetooth, NFC, robuste Hardware, ATEX-Zone-1-Eignung und KI-gestützten Wissenszugriff in einem industriellen Edge-Hub für den Einsatz im Feld.",
      ctaPrimary: "Pilotprojekt anfragen",
      ctaSecondary: "Use Cases ansehen",
      badges: ["ATEX Zone 1", "Class 1 Division 1", "IP68", "MIL-STD 810H", "Public & Private 5G", "Wi-Fi 6/6E", "Edge AI"],
    },
    trust: {
      headline: "Im Einsatz bei führenden Industrie-Unternehmen weltweit",
      logos: ["ExxonMobil", "BP", "Shell", "Honeywell", "Aramco", "Ericsson", "Marathon", "Wood", "ADNOC"],
    },
    problem: {
      label: "DAS PROBLEM",
      headline: "Industriearbeit wird digitaler. Aber im Feld bleibt vieles analog.",
      intro:
        "In rauen und explosionsgefährdeten Industrieumgebungen scheitern digitale Prozesse oft an der Realität vor Ort: fehlende Konnektivität, ungeeignete Hardware, isolierte Sensordaten und fehlender Zugriff auf Wissen genau dann, wenn es gebraucht wird.",
      cards: [
        {
          title: "Keine stabile Konnektivität in Ex-Bereichen",
          text:
            "Viele Anlagenbereiche sind funktechnisch schwer erreichbar. Öffentliches 5G endet oft am Werkstor, WLAN reicht nicht bis in jede Zone und klassische IT-Hardware darf nicht überall eingesetzt werden.",
        },
        {
          title: "WLAN reicht oft nicht aus",
          text:
            "In Industrieanlagen blockieren Stahl, Beton, Maschinen, Tanks und Rohrleitungen die Verbindung. Remote Assist, Push-to-Talk, Live-Daten und Telemetrie funktionieren dadurch in der Praxis oft nur eingeschränkt.",
        },
        {
          title: "Sensor- und Maschinendaten bleiben ungenutzt",
          text:
            "Vibration, Lärm, Temperatur, Standort, Bewegung und Maschinenzustände liefern wertvolle Hinweise. Doch viele dieser Daten werden nicht strukturiert erfasst, übertragen oder ausgewertet.",
        },
        {
          title: "Remote Assist funktioniert im Feld oft schlecht",
          text:
            "Expertenwissen ist vorhanden, aber nicht dort, wo der Techniker gerade arbeitet. Video-Support, Teams, Zoom oder Push-to-Talk scheitern häufig an Hardware, Netzabdeckung oder Umgebung.",
        },
        {
          title: "Techniker haben keinen einfachen Zugriff auf Wissen",
          text:
            "Handbücher, Wartungsdaten, Prozessinformationen und Expertenwissen liegen oft in PDFs, Ordnern, Systemen oder Papierausdrucken. Im Feld fehlt der schnelle, sichere und einfache Zugriff.",
        },
        {
          title: "Industrial AI braucht Felddaten",
          text:
            "Viele Industrial-AI-Initiativen scheitern nicht an der Modellqualität, sondern daran, dass relevante, vollständige, genaue und aktuelle Daten aus dem Feld fehlen. RuggedEdge setzt genau dort an: bei schwer erreichbaren Daten aus Anlagen, Sensoren, Werkzeugen und Arbeitsprozessen.",
        },
      ],
      quote:
        "„Alle Informationen, die ein Techniker braucht, könnten direkt im Gerät verfügbar sein — genau dort, wo die Arbeit passiert.”",
      quoteAttr: "RuggedEdge — Praxisbeispiel aus dem Feld",
    },
    solution: {
      label: "DIE LÖSUNG",
      headline: "EdgeOne bringt Konnektivität, Wissen und Sensordaten direkt ins Feld.",
      intro:
        "EdgeOne von RuggedEdge ist ein industrieller 5G-IIoT-Edge-Hub für Connected Worker, Remote Assist, Sensorintegration und KI-gestützten Wissenszugriff in rauen und explosionsgefährdeten Umgebungen.",
      text1:
        "Das Gerät verbindet Mitarbeiter, Sensoren, Maschinen und Experten über Public oder Private 5G, Wi-Fi 6/6E, Bluetooth und NFC. Dadurch wird EdgeOne zur robusten Schnittstelle zwischen Feldarbeit, industriellen Daten und digitalen Anwendungen.",
      text2:
        "Je nach Projektsetup kann der KI-Wissenszugriff cloudbasiert, hybrid, on-premise oder perspektivisch lokal am Gerät umgesetzt werden. Für Pilotprojekte wird das passende Betriebsmodell gemeinsam anhand von Sicherheits-, Datenschutz- und Netzwerkanforderungen definiert.",
      bullets: [
        "5G / Private 5G für industrielle Campus- und Feldanwendungen",
        "Wi-Fi 6 / 6E für leistungsfähige lokale Konnektivität",
        "Bluetooth / NFC für Sensoren, Wearables und Feldgeräte",
        "Eigensicher für ATEX-Zone-1-Umgebungen",
        "Android-basiertes Enterprise-Betriebssystem",
        "Sensor- und Wearable-Anbindung",
        "Remote Assist und Push-to-Talk",
        "Edge AI und KI-gestützter Wissenszugriff",
      ],
      cta: "Pilotprojekt besprechen",
    },
    platform: {
      label: "DIE PLATTFORM",
      headline: "RuggedEdge ist mehr als ein Gerät: Connect. Collect. Context.",
      intro:
        "EdgeOne ist Teil einer industriellen Plattform, die Konnektivität, Felddaten und Wissen zusammenführt — als belastbare Grundlage für dateninformierte Industrial-AI-Anwendungen im Feld.",
      pillars: [
        {
          tag: "01 · Connect",
          title: "Connect — Konnektivität im Feld",
          text:
            "Public und Private 5G, Wi-Fi 6/6E, Bluetooth und NFC verbinden Mitarbeiter, Sensoren, Maschinen und Experten — auch in ATEX-Zone-1- und schwer erreichbaren Bereichen.",
        },
        {
          tag: "02 · Collect",
          title: "Collect — Felddaten aus realer Arbeit",
          text:
            "EdgeOne erfasst strukturierte Daten von Sensoren, Wearables, Smart Tools und Maschinen sowie aus Arbeitsprozessen — per Sprache, Formular, Push-to-Talk oder Wearable-Anbindung.",
        },
        {
          tag: "03 · Context",
          title: "Context — Wissen, das im Feld nutzbar wird",
          text:
            "Handbücher, Wartungsdaten und Prozessinformationen werden zu einem kontextbezogenen, KI-gestützten Wissenszugriff — cloudbasiert, hybrid, on-premise oder perspektivisch lokal am Gerät.",
        },
      ],
      closing:
        "So entstehen aus verstreuten Industriedaten belastbare Grundlagen für Industrial AI — direkt dort, wo die Arbeit passiert.",
    },
    download: {
      label: "DOWNLOAD",
      headline: "RuggedEdge Kurzpräsentation herunterladen",
      text:
        "Sie möchten die wichtigsten Informationen zu EdgeOne, RuggedEdge-Plattform, Use Cases, Pioneer Program und ALEGER GLOBAL kompakt weitergeben? Laden Sie die Präsentation als PDF herunter.",
      cta: "PDF-Präsentation herunterladen",
      note:
        "Ideal zur internen Abstimmung mit Instandhaltung, HSE, IT/OT, Einkauf oder Geschäftsführung.",
      file: "/downloads/ruggededge-kurzpraesentation-aleger-global.pdf",
      meta: "PDF · ca. 2 MB",
      secondaryHeadline: "Noch nicht bereit für ein Gespräch?",
      secondaryText:
        "Laden Sie zunächst die kompakte RuggedEdge-Präsentation herunter und teilen Sie sie intern mit Ihrem Team.",
      secondaryCta: "PDF ansehen",
    },
    useCases: {
      label: "ANWENDUNGSFÄLLE",
      headline: "Nicht nur Features. Konkrete Anwendungen für Ihre Industrieumgebung.",
      intro:
        "EdgeOne wird nicht als einzelnes Gerät gedacht, sondern als Lösungsbaustein für konkrete industrielle Use Cases. Gemeinsam mit ALEGER GLOBAL definieren Sie den passenden Einstieg und testen den Nutzen in einem realistischen Pilotprojekt.",
      typicalLabel: "Typische Anwendungen",
      cards: [
        {
          key: "remote-assist",
          title: "Remote Assist für Wartung & Instandhaltung",
          text:
            "Techniker im Feld verbinden sich per Video, Audio oder Collaboration-App mit Experten aus der Zentrale. Der Experte sieht, was vor Ort passiert, und unterstützt direkt bei Diagnose, Reparatur oder Inspektion.",
          typical: [
            "Wartung und Störungsbehebung",
            "Inspektion komplexer Anlagen",
            "Expertenunterstützung aus der Ferne",
            "Reduktion unnötiger Anreisen",
          ],
          cta: "Use Case besprechen",
        },
        {
          key: "push-to-talk",
          title: "Push-to-Talk Kommunikation im Feld",
          text:
            "EdgeOne unterstützt digitale Kommunikation für Teams in rauen Industrieumgebungen. Mitarbeiter können standortübergreifend kommunizieren, ohne auf klassische Funkgeräte oder unzuverlässige Verbindungen angewiesen zu sein.",
          typical: [
            "Teamkommunikation in Anlagen",
            "Kommunikation mit Leitstand oder Experten",
            "Gruppenkommunikation für Wartungsteams",
            "Ersatz oder Ergänzung klassischer Funklösungen",
          ],
          cta: "Kommunikationslösung prüfen",
        },
        {
          key: "private-5g",
          title: "Private-5G-Gateway für Ex-Zonen",
          text:
            "EdgeOne kann als industrieller Zugangspunkt für Public oder Private 5G genutzt werden und Konnektivität in Bereiche bringen, in denen klassische Netzabdeckung oder WLAN nicht ausreichen.",
          typical: [
            "Private-5G-Campusnetze",
            "Raffinerien, Chemieanlagen und Tanklager",
            "temporäre Konnektivität in schwer erreichbaren Bereichen",
            "Verbindung von Feldgeräten, Sensoren und Wearables",
          ],
          cta: "5G-Use-Case prüfen",
        },
        {
          key: "connected-worker-safety",
          title: "Connected Worker Safety mit EdgeOne & EdgeWatch",
          text:
            "EdgeOne kann Mitarbeiter, Wearables und Sicherheitsfunktionen verbinden. Optional kann EdgeWatch in ein Connected-Worker-Monitoring integriert werden, um Vitaldaten, SpO2, Aktivitätslevel, Fall- bzw. Man-Down-Ereignisse, GPS-Position, Lärmpegel und Warnmeldungen sichtbar zu machen.",
          typical: [
            "Man-Down-Erkennung",
            "Mitarbeiterlokalisierung",
            "Lärm- und Sicherheitsmonitoring",
            "Wearable-Anbindung",
            "Geo-Fencing für gefährliche Bereiche",
            "Unterstützung von Alleinarbeit und Notfallszenarien",
          ],
          cta: "Safety-Pilot anfragen",
        },
        {
          key: "iot",
          title: "IoT-Datenerfassung von Sensoren und Maschinen",
          text:
            "EdgeOne kann als Schnittstelle zwischen Feldsensoren, Maschinen, Tools und übergeordneten Systemen dienen. Daten wie Vibration, Lärm, Temperatur, Bewegung oder Standort können erfasst und weiterverarbeitet werden.",
          typical: [
            "Zustandsüberwachung",
            "Anlagenmonitoring",
            "Sensordatenaggregation",
            "Grundlage für Predictive-Maintenance-Szenarien",
          ],
          cta: "IoT-Pilot besprechen",
        },
        {
          key: "ai-knowledge",
          title: "AI-Wissensdatenbank für Techniker",
          text:
            "Handbücher, Wartungsunterlagen, Prozessinformationen und technische Dokumente können für einen KI-gestützten Wissenszugriff aufbereitet werden. Techniker können Informationen per Sprache abfragen und schneller auf relevantes Wissen zugreifen.",
          typical: [
            "Zugriff auf Wartungsanleitungen",
            "Unterstützung bei Fehlerdiagnose",
            "Wissenstransfer an neue Mitarbeiter",
            "Reduktion von Papierunterlagen im Feld",
          ],
          cta: "AI-Wissenszugriff testen",
        },
        {
          key: "voice-docs",
          title: "Smart Forms / Sprachdokumentation",
          text:
            "Statt nach dem Einsatz Formulare manuell auszufüllen, kann der Techniker seine Arbeit per natürlicher Sprache dokumentieren. Der Smart-Forms-Agent interpretiert die Angaben, unterstützt beim Ausfüllen strukturierter Formulare und kann fehlende Pflichtinformationen abfragen.",
          typical: [
            "Wartungsberichte",
            "Inspektionsprotokolle",
            "Sicherheitsfreigaben",
            "Lockout/Tagout-Dokumentation",
            "Incident- und Near-Miss-Reports",
            "Serviceberichte",
          ],
          cta: "Smart Forms testen",
        },
      ],
    },
    industries: {
      label: "ZIELBRANCHEN",
      headline: "Für industrielle Umgebungen, in denen normale Hardware an Grenzen stößt.",
      intro:
        "EdgeOne eignet sich besonders für Unternehmen, bei denen Konnektivität, Sicherheit, robuste Hardware, Remote Support und Datenzugriff im Feld geschäftskritisch sind.",
      cards: [
        { title: "Öl & Gas", text: "Für Bohrinseln, Förderanlagen, Pipelines, Raffinerien und entlegene Standorte, an denen robuste Konnektivität, Sicherheit und Remote Assist entscheidend sind." },
        { title: "Chemie", text: "Für explosionsgefährdete Produktionsbereiche, in denen sichere Kommunikation, Sensorik, Dokumentation und Mitarbeiterunterstützung benötigt werden." },
        { title: "Raffinerien", text: "Für komplexe Anlagen mit Stahl, Rohrleitungen, Tanks und schwieriger Funkabdeckung — ideal für Remote Assist, Private 5G und Connected Worker." },
        { title: "Energie", text: "Für Energieversorger, Kraftwerke, Infrastrukturbetreiber und technische Teams, die robuste Konnektivität und digitale Unterstützung im Feld benötigen." },
        { title: "Pharma / Prozessindustrie", text: "Für regulierte Umgebungen mit hohen Anforderungen an Prozesssicherheit, Dokumentation, Qualitätskontrolle und technische Unterstützung." },
        { title: "Tanklager", text: "Für gefährdete Lager- und Umschlagbereiche, in denen zuverlässige Kommunikation, Tracking, Sicherheit und Monitoring eine zentrale Rolle spielen." },
        { title: "Industrieanlagen & Instandhaltung", text: "Für Betreiber großer Produktions- und Instandhaltungsumgebungen, in denen Sensorik, Remote Support und digitale Workflows miteinander verbunden werden sollen." },
        { title: "Private-5G-Campusnetze", text: "Für Unternehmen und Integratoren, die industrielle 5G-Anwendungen mit realen Feldprozessen, Endgeräten, Sensoren und Mitarbeitern verbinden möchten." },
      ],
    },
    pilot: {
      label: "IHR EINSTIEG",
      teaserHeadline: "Ihr Einstieg: RuggedEdge Pilotprojekt",
      teaserText: "Use Case prüfen, Geräte testen, Nutzen im Feld validieren. ALEGER GLOBAL begleitet Sie vom ersten Workshop bis zur praktischen Teststellung.",
      teaserCta: "Pilotprojekt anfragen",
      headline: "RuggedEdge Pilotprojekt für Industrie & ATEX-Umgebungen",
      intro:
        "Der sinnvollste Einstieg ist kein reiner Gerätekauf, sondern ein klar definiertes Pilotprojekt. Gemeinsam prüfen wir, welcher Use Case in Ihrer Umgebung den größten Nutzen bringt — und testen EdgeOne mit Ihren realen Anforderungen.",
      sub:
        "Vom Use-Case-Workshop bis zur Teststellung: ALEGER GLOBAL begleitet Sie von der Idee bis zur praktischen Validierung im Feld.",
      includesLabel: "Inhalte des Pilotprojekts",
      includes: [
        "Use-Case-Workshop mit ALEGER GLOBAL",
        "Auswahl des passenden Pilot-Szenarios",
        "EdgeOne-Geräte für Teststellung oder Pilotbetrieb",
        "Zubehör nach Bedarf, z. B. Headsets, Akkus, Ladelösungen",
        "technische Abstimmung zu ATEX, Netz, Standort und Einsatzumgebung",
        "Konfiguration der Geräte und Anwendungen",
        "optional: AI-/Dokumentenintegration für Wartungswissen und Prozessinformationen",
        "Unterstützung bei Remote Assist, Push-to-Talk, IoT-Daten oder Connected Worker Safety",
        "Training, Support und gemeinsame Auswertung",
      ],
      cta: "Pilotprojekt anfragen",
    },
    specs: {
      label: "TECHNISCHE DATEN",
      headline: "EdgeOne — kompakter Überblick",
      intro:
        "Die wichtigsten technischen Eckdaten auf einen Blick. Weitere Details prüfen wir gerne im Rahmen Ihrer konkreten Anwendung.",
      rows: [
        { k: "Zertifizierung", v: "ATEX Zone 1, Class 1 Division 1, eigensicher für explosionsgefährdete Bereiche" },
        { k: "Konnektivität", v: "Public / Private 5G, Wi-Fi 6, Wi-Fi 6E, Bluetooth 5.2, NFC" },
        { k: "Betriebssystem", v: "Enterprise Android OS" },
        { k: "Prozessor", v: "Qualcomm QCM6490, Kryo 670 CPU-Technologie mit KI-Engine" },
        { k: "Speicher", v: "4 GB RAM, 64 GB interner Speicher" },
        { k: "Akku", v: "4209 mAh, austauschbar" },
        { k: "Robustheit", v: "IP68, MIL-STD 810H" },
        { k: "Betriebstemperatur", v: "−20 °C bis +60 °C" },
        { k: "Ortung", v: "GPS, A-GPS, Galileo, Glonass, Beidou" },
        { k: "Sensoren", v: "Accelerometer, Gyroscope, Magnetic, Barometer" },
        { k: "SIM", v: "Nano-SIM und eSIM" },
      ],
      cta: "Technische Details ansehen",
    },
    why: {
      label: "WARUM ALEGER GLOBAL?",
      headline: "Ihr Partner für Beratung, Pilotierung und Projektgeschäft.",
      intro:
        "Eine Lösung wie RuggedEdge verkauft man nicht einfach als Hardware. Entscheidend ist der richtige Use Case, die technische Einbettung, die Akzeptanz im Feld und ein realistischer Weg vom Pilot zum Rollout. Genau hier unterstützt ALEGER GLOBAL.",
      positioning:
        "ALEGER GLOBAL übersetzt RuggedEdge-Technologie in konkrete Industrieprojekte — von der ersten Use-Case-Idee bis zum Pilotbetrieb und Rollout.",
      cards: [
        { title: "Beratung zum passenden Use Case", text: "Wir prüfen gemeinsam, welcher Use Case für Ihre Umgebung sinnvoll ist: Remote Assist, Push-to-Talk, Private 5G, IoT-Daten, Connected Worker Safety oder KI-Wissenszugriff." },
        { title: "Hardware-Beschaffung und Zubehör", text: "ALEGER GLOBAL unterstützt bei Auswahl, Beschaffung und Zusammenstellung von Geräten, Zubehör, Akkus, Headsets und ergänzender Rugged-/ATEX-Hardware." },
        { title: "Pilotprojekt-Setup", text: "Wir strukturieren den Einstieg als Pilotprojekt: Zielsetzung, Geräte, Einsatzort, technische Anforderungen, Teststellung, Auswertung und nächster Schritt." },
        { title: "Integration mit Partnern und Systemhäusern", text: "Wir arbeiten mit Integratoren, Telekommunikationspartnern, Private-5G-Projektteams und IT-/OT-Umgebungen zusammen, um RuggedEdge sinnvoll in bestehende Projekte einzubetten." },
        { title: "ATEX- und Rugged-Hardware-Erfahrung", text: "ALEGER GLOBAL kennt die Anforderungen industrieller Spezialhardware, explosionsgefährdeter Bereiche und robuster mobiler Endgeräte." },
        { title: "Ansprechpartner in DACH", text: "Kunden und Partner erhalten einen erreichbaren Ansprechpartner für Beratung, Angebot, Projektklärung, Pilotierung und Rollout in Deutschland, Österreich und der Schweiz." },
        { title: "Projektgeschäft statt reiner Produktverkauf", text: "Unser Fokus liegt nicht auf dem schnellen Geräteverkauf, sondern auf belastbaren industriellen Lösungen, die im Feld funktionieren." },
      ],
      cta: "Mit ALEGER GLOBAL sprechen",
    },
    faq: {
      label: "FAQ",
      headline: "Häufige Fragen",
      items: [
        { q: "Ist EdgeOne für explosionsgefährdete Bereiche geeignet?", a: "EdgeOne ist für ATEX-Zone-1-Umgebungen und Class 1 Division 1 positioniert. Die konkrete Eignung für Ihren Standort prüfen wir gemeinsam anhand Ihrer Einsatzbedingungen und Anforderungen." },
        { q: "Welche Netze unterstützt EdgeOne?", a: "EdgeOne unterstützt Public und Private 5G, Wi-Fi 6/6E, Bluetooth 5.2 und NFC. Dadurch kann das Gerät sowohl mit Mobilfunknetzen als auch mit lokalen Feldgeräten, Sensoren und Wearables verbunden werden." },
        { q: "Kann EdgeOne für Remote Assist eingesetzt werden?", a: "Ja. EdgeOne kann Remote-Assist-Anwendungen wie Video, Audio, Collaboration und Expertenunterstützung im Feld unterstützen. Die konkrete Umsetzung hängt vom Use Case, Netz und Zubehör ab." },
        { q: "Kann EdgeOne Sensor- und Maschinendaten erfassen?", a: "EdgeOne kann als Schnittstelle für Sensoren, Wearables, Smart Tools und Feldgeräte eingesetzt werden. Welche Daten erfasst und integriert werden, prüfen wir im Projekt anhand Ihrer Anlagen- und Systemumgebung." },
        { q: "Wie funktioniert der KI-Wissenszugriff?", a: "Ausgewählte Dokumente, Handbücher, Wartungsinformationen oder Prozessdaten können für einen KI-gestützten Wissenszugriff aufbereitet werden. Je nach Setup kann die Lösung lokal, on-premise oder cloudbasiert umgesetzt werden." },
        { q: "Warum sollte ich nicht einfach nur ein Gerät kaufen?", a: "Der größte Nutzen entsteht, wenn EdgeOne in einen konkreten Use Case eingebettet wird. Deshalb empfiehlt ALEGER GLOBAL den Einstieg über ein Pilotprojekt mit klarer Zielsetzung, technischer Abstimmung und gemeinsamer Auswertung." },
        { q: "Bietet ALEGER GLOBAL Unterstützung in DACH?", a: "Ja. ALEGER GLOBAL unterstützt Kunden und Partner in Deutschland, Österreich und der Schweiz bei Beratung, Pilotierung, Beschaffung und Projektumsetzung." },
        { q: "Was kostet ein Pilotprojekt?", a: "Die Kosten hängen von Use Case, Geräteanzahl, Zubehör, Integrationsaufwand und gewünschtem Projektumfang ab. Nach einer kurzen Erstabstimmung erstellen wir ein passendes Angebot." },
      ],
    },
    contact: {
      label: "KONTAKT",
      headline: "Lassen Sie uns Ihren Use Case prüfen.",
      intro:
        "Sie möchten herausfinden, ob RuggedEdge für Ihre Anlage, Ihr 5G-Projekt oder Ihre Instandhaltungsprozesse geeignet ist? Beschreiben Sie kurz Ihren Einsatzfall — ALEGER GLOBAL schlägt Ihnen ein sinnvolles Pilot-Setup vor.",
      cta: "Demo / Pilotprojekt anfragen",
      info: {
        emailLabel: "E-Mail",
        phoneLabel: "Telefon",
        hqLabel: "HQ",
        hq: "Ebensee, Österreich",
      },
      form: {
        name: "Vor- und Nachname",
        email: "E-Mail",
        company: "Unternehmen",
        phone: "Telefon",
        industry: "Branche",
        useCase: "Gewünschter Use Case",
        message: "Ihre Anwendung & Anfrage",
        placeholder: "Anzahl Geräte, Einsatzort, ATEX-Anforderung, gewünschter Use Case, vorhandene Netzinfrastruktur …",
        consent: "Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu.",
        submit: "Beratung anfragen",
        sending: "Wird gesendet …",
        successTitle: "Nachricht erhalten",
        successText: "Ein ALEGER GLOBAL-Spezialist meldet sich innerhalb eines Werktags bei Ihnen.",
        successAnother: "Weitere Anfrage senden →",
        errEmpty: "Bitte füllen Sie die Pflichtfelder aus",
        errGeneric: "Konnte nicht gesendet werden. Bitte erneut versuchen.",
        thankYou: "Danke — wir melden uns innerhalb eines Werktags.",
        industryPlaceholder: "Bitte wählen",
        usecasePlaceholder: "Bitte wählen",
      },
    },
    footer: {
      about:
        "ALEGER GLOBAL GmbH — Beratung, Pilotierung und Vertrieb von RuggedEdge-Lösungen für industrielle 5G-, ATEX-, Connected-Worker- und Edge-AI-Anwendungen.",
      cols: [
        { title: "LÖSUNGEN", items: ["Remote Assist", "Push-to-Talk", "Private 5G Gateway", "Connected Worker Safety", "IoT-Datenerfassung", "AI-Wissensdatenbank"] },
        { title: "BRANCHEN", items: ["Öl & Gas", "Chemie", "Raffinerien", "Energie", "Pharma", "Tanklager", "Private-5G-Campusnetze"] },
        { title: "PRODUKT", items: ["EdgeOne", "Technische Daten", "Pilotprojekt", "Kontakt"] },
        { title: "KONTAKT", items: ["Ischlerstrasse 22, 4802 Ebensee, Österreich", "+43 7612 219 6010", "info@alegerglobal.com"] },
      ],
      rights: "Alle Rechte vorbehalten. RuggedEdge® und EdgeOne™ sind Marken der RuggedEdge, Inc.",
      legal: { imprint: "Impressum", privacy: "Datenschutz", terms: "AGB" },
    },
    edgeOnePage: {
      back: "Zurück zur Startseite",
      eyebrow: "Flaggschiff-Gerät",
      h1: "EdgeOne™",
      sub: "Speziell entwickelter industrieller Edge-Computing IIoT-Hub. Zuverlässig & robust. Skalierbar & sicher.",
      intro:
        "EdgeOne von RuggedEdge ist ein industrieller 5G-IIoT-Edge-Hub für ATEX-Zone-1-Umgebungen. Das Gerät verbindet Mitarbeiter, Sensoren, Maschinen und Experten über Public und Private 5G, Wi-Fi 6/6E, Bluetooth und NFC und unterstützt Remote Assist, Push-to-Talk, Connected Worker Safety, Sensor- und Maschinendatenerfassung sowie KI-gestützten Wissenszugriff. Die folgenden Spezifikationen geben einen Überblick über Hardware, Konnektivität, Zertifizierungen und unterstütztes Ökosystem für den Einsatz in Öl & Gas, Chemie, Raffinerien, Energie und industrieller Instandhaltung.",
      metaTitle: "EdgeOne — ATEX 5G Edge Gateway | ALEGER GLOBAL",
      metaDescription:
        "Technische Daten und unterstütztes Ökosystem zum RuggedEdge EdgeOne ATEX 5G Edge Gateway. Eigensicher für ATEX Zone 1, IP68, MIL-STD 810H, Public/Private 5G, Wi-Fi 6/6E und Enterprise Android.",
      badges: ["ATEX Zone 1", "Class 1 Div 1", "IP68", "MIL-STD 810H", "5G", "Wi-Fi 6E"],
      ctaQuote: "Angebot anfragen",
      specsHeading: "Vollständige Spezifikationen",
      ecosystemHeading: "Unterstütztes Ökosystem",
      ecosystemIntro: "EdgeOne fungiert als Konnektivitäts-Hub für Ihre bestehenden Feldgeräte und Wearables.",
      quoteHeading: "Ihr EdgeOne-Angebot anfragen",
      quoteIntro: "Erzählen Sie uns von Ihren Standorten und Ihrer geplanten Flottengröße. ALEGER meldet sich innerhalb eines Werktags.",
      fullSpecs: [
        { group: "Prozessor & Speicher", items: [["CPU", "Qualcomm QCM6490 · Kryo 670 · KI-Engine 6. Gen."], ["RAM", "4 GB"], ["Speicher", "64 GB intern"], ["Betriebssystem", "Enterprise Android"]] },
        { group: "Display & Gehäuse", items: [["Display", '2,4" FHD Touch · 240×320 · Gorilla Glass'], ["Abmessungen", '4,91" × 2,55" × 1,46" (125 × 65 × 37 mm)'], ["Gewicht", "320 g (11,3 oz)"], ["Akku", "4209 mAh · austauschbar"]] },
        { group: "Konnektivität", items: [["5G", "n1/n2/n3/n5/n7/n8/n12/n20/n25/n28/n38/n40/n41/n48/n65/n71/n77/n78/n79"], ["4G FDD", "1,2,3,4,5,7,8,12,13,14,17,20,25,26,28,29,30,66,71"], ["4G TDD", "38,39,40,41,42,43,48"], ["Wi-Fi", "Wi-Fi 6 & Wi-Fi 6E · 802.11 a/b/g/n/ac/ax/e/k/r/v"], ["Bluetooth", "BT 5.2"], ["NFC / SIM", "NFC · Nano SIM + eSIM"], ["Hotspot", "Bis zu 32 Nutzer"]] },
        { group: "Sensoren & GPS", items: [["Sensoren", "Beschleunigungsmesser · Gyroskop · Magnetometer · Barometer"], ["GNSS", "GPS · A-GPS · Galileo · Glonass · Beidou"]] },
        { group: "Zertifizierungen", items: [["Ex-Schutz", "Class 1 Division 1 · ATEX Zone 1 · Eigensicher"], ["IP-Schutzart", "IP68 (Staub / Wasser)"], ["Militärstandard", "MIL-STD 810H"], ["Betriebstemperatur", "-20 °C bis +60 °C"]] },
      ],
      peripherals: [
        "Wearable Computing", "Gas-Sensoren", "Temperatur-Messgeräte", "Smart Tools",
        "Ultraschall-Sonden", "Elektronische Messgeräte", "High-Res & IR-Kameras", "Health-Monitore",
        "Gehörschutz", "Funkgeräte (LMR)", "Druckkalibratoren", "Scanner",
        "PSA-Tracking & Compliance", "Asset-Tracking & Wartung",
      ],
    },
    useCasePage: {
      back: "Alle Anwendungsfälle",
      eyebrow: "Anwendungsfall",
      ctaQuote: "Diesen Anwendungsfall durchsprechen",
      problemLabel: "Das Problem",
      problemHeading: "Warum das heute schmerzt.",
      solutionLabel: "Die Lösung",
      solutionHeading: "So macht EdgeOne den Unterschied.",
      benefitsLabel: "Ihr Nutzen",
      benefitsHeading: "Messbar. Vom ersten Tag an.",
      workflowLabel: "So läuft die Einführung",
      workflowHeading: "Vom Konzept zum Produktiveinsatz.",
      quoteHeading: "Diesen Use Case auf Ihrer Anlage testen.",
      quoteIntro: "Erzählen Sie uns kurz, wo Sie diesen Use Case einsetzen würden. Wir melden uns innerhalb eines Werktags.",
      relatedLabel: "Weitere Anwendungsfälle",
      relatedHeading: "Das könnte Sie auch interessieren.",
      relatedMore: "Mehr lesen",
    },
  },

  en: {
    meta: {
      title: "ATEX 5G Edge Gateway for Industry | ALEGER GLOBAL",
      description:
        "EdgeOne from RuggedEdge connects workers, sensors, machines and experts in harsh and hazardous industrial environments. ALEGER GLOBAL supports Remote Assist, Private 5G, IoT data, Connected Worker Safety and Edge AI from consulting to pilot projects.",
    },
    nav: {
      problem: "Problem",
      solution: "Solution",
      platform: "Platform",
      useCases: "Use Cases",
      industries: "Industries",
      pilot: "Pilot project",
      specs: "Technical data",
      whyAleger: "Why ALEGER",
      faq: "FAQ",
      contact: "Contact",
      ctaPrimary: "Request pilot project",
      ctaSecondary: "View use cases",
    },
    hero: {
      eyebrow: "ALEGER × RUGGEDEDGE — ATEX 5G EDGE GATEWAY",
      h1: "ATEX 5G Edge Gateway for Industry, Remote Assist and IoT Data",
      sub:
        "With EdgeOne from RuggedEdge, ALEGER GLOBAL connects workers, sensors, machines and experts in harsh and hazardous industrial environments.",
      text:
        "EdgeOne combines public and private 5G, Wi-Fi 6/6E, Bluetooth, NFC, rugged hardware, ATEX Zone 1 suitability and AI-powered knowledge access in one industrial edge hub for field operations.",
      ctaPrimary: "Request pilot project",
      ctaSecondary: "View use cases",
      badges: ["ATEX Zone 1", "Class 1 Division 1", "IP68", "MIL-STD 810H", "Public & Private 5G", "Wi-Fi 6/6E", "Edge AI"],
    },
    trust: {
      headline: "Used by leading industrial companies worldwide",
      logos: ["ExxonMobil", "BP", "Shell", "Honeywell", "Aramco", "Ericsson", "Marathon", "Wood", "ADNOC"],
    },
    problem: {
      label: "THE PROBLEM",
      headline: "Industrial work is becoming digital. But in the field, much of it remains analog.",
      intro:
        "In harsh and hazardous industrial environments, digital processes often fail because of the reality on site: missing connectivity, unsuitable hardware, isolated sensor data and no access to knowledge exactly when it is needed.",
      cards: [
        { title: "No stable connectivity in hazardous areas", text: "Many plant areas are difficult to cover with wireless connectivity. Public 5G often ends at the factory gate, Wi-Fi does not reach every zone and standard IT hardware cannot be used everywhere." },
        { title: "Wi-Fi is often not enough", text: "In industrial plants, steel, concrete, machines, tanks and piping block the connection. Remote Assist, Push-to-Talk, live data and telemetry often only work with limitations in real-world operations." },
        { title: "Sensor and machine data remain unused", text: "Vibration, noise, temperature, location, movement and machine conditions provide valuable insights. But much of this data is not collected, transmitted or analyzed in a structured way." },
        { title: "Remote Assist often fails in the field", text: "Expert knowledge exists, but not where the technician is working. Video support, Teams, Zoom or Push-to-Talk often fail because of hardware, network coverage or the operating environment." },
        { title: "Technicians have no simple access to knowledge", text: "Manuals, maintenance data, process information and expert knowledge often sit in PDFs, folders, systems or paper printouts. In the field, fast, safe and simple access is missing." },
        { title: "Industrial AI needs field data", text: "Many industrial AI initiatives do not fail because of model quality, but because relevant, complete, accurate and timely field data is missing. RuggedEdge addresses exactly this challenge: capturing hard-to-reach data from assets, sensors, tools and work processes." },
      ],
      quote:
        "“All the information a technician needs could be available directly on the device — exactly where the work happens.”",
      quoteAttr: "RuggedEdge — Field Use Case Insight",
    },
    solution: {
      label: "THE SOLUTION",
      headline: "EdgeOne brings connectivity, knowledge and sensor data directly into the field.",
      intro:
        "EdgeOne from RuggedEdge is an industrial 5G IIoT edge hub for Connected Worker, Remote Assist, sensor integration and AI-powered knowledge access in harsh and hazardous environments.",
      text1:
        "The device connects workers, sensors, machines and experts via public or private 5G, Wi-Fi 6/6E, Bluetooth and NFC. This makes EdgeOne a rugged interface between field work, industrial data and digital applications.",
      text2:
        "Depending on the project setup, AI-powered knowledge access can be implemented cloud-based, hybrid, on-premise or, prospectively, locally on the device. For pilot projects, the appropriate operating model is defined together based on security, data protection and network requirements.",
      bullets: [
        "5G / Private 5G for industrial campus and field applications",
        "Wi-Fi 6 / 6E for powerful local connectivity",
        "Bluetooth / NFC for sensors, wearables and field devices",
        "Intrinsically safe for ATEX Zone 1 environments",
        "Android-based enterprise operating system",
        "Sensor and wearable integration",
        "Remote Assist and Push-to-Talk",
        "Edge AI and AI-powered knowledge access",
      ],
      cta: "Discuss pilot project",
    },
    platform: {
      label: "THE PLATFORM",
      headline: "RuggedEdge is more than a device: Connect. Collect. Context.",
      intro:
        "EdgeOne is part of an industrial platform that brings together connectivity, field data and knowledge — as a robust foundation for data-informed industrial AI applications in the field.",
      pillars: [
        {
          tag: "01 · Connect",
          title: "Connect — connectivity in the field",
          text:
            "Public and private 5G, Wi-Fi 6/6E, Bluetooth and NFC connect workers, sensors, machines and experts — even in ATEX Zone 1 and hard-to-reach areas.",
        },
        {
          tag: "02 · Collect",
          title: "Collect — field data from real work",
          text:
            "EdgeOne captures structured data from sensors, wearables, smart tools and machines as well as from work processes — via voice, form, Push-to-Talk or wearable integration.",
        },
        {
          tag: "03 · Context",
          title: "Context — knowledge that becomes usable in the field",
          text:
            "Manuals, maintenance data and process information turn into contextual, AI-powered knowledge access — cloud-based, hybrid, on-premise or, prospectively, locally on the device.",
        },
      ],
      closing:
        "This turns scattered industrial data into reliable foundations for industrial AI — right where the work happens.",
    },
    download: {
      label: "DOWNLOAD",
      headline: "Download the RuggedEdge short presentation",
      text:
        "Would you like to share the key information about EdgeOne, the RuggedEdge platform, use cases, the Pioneer Program and ALEGER GLOBAL in a compact format? Download the presentation as a PDF.",
      cta: "Download PDF presentation",
      note:
        "Ideal for internal alignment with maintenance, HSE, IT/OT, procurement or management.",
      file: "/downloads/ruggededge-short-presentation-aleger-global.pdf",
      meta: "PDF · approx. 2 MB",
      secondaryHeadline: "Not ready for a conversation yet?",
      secondaryText:
        "Download the compact RuggedEdge presentation first and share it internally with your team.",
      secondaryCta: "View PDF",
    },
    useCases: {
      label: "USE CASES",
      headline: "Not just features. Real applications for your industrial environment.",
      intro:
        "EdgeOne is not positioned as a standalone device, but as a solution component for specific industrial use cases. Together with ALEGER GLOBAL, you define the right entry point and test the value in a realistic pilot project.",
      typicalLabel: "Typical applications",
      cards: [
        {
          key: "remote-assist",
          title: "Remote Assist for maintenance and service",
          text: "Technicians in the field connect with experts at headquarters via video, audio or collaboration apps. The expert sees what is happening on site and supports diagnosis, repair or inspection in real time.",
          typical: ["Maintenance and troubleshooting", "Inspection of complex plants", "Remote expert support", "Reduction of unnecessary travel"],
          cta: "Discuss use case",
        },
        {
          key: "push-to-talk",
          title: "Push-to-Talk communication in the field",
          text: "EdgeOne supports digital communication for teams in harsh industrial environments. Workers can communicate across locations without relying on traditional radios or unreliable connections.",
          typical: ["Team communication in plants", "Communication with control room or experts", "Group communication for maintenance teams", "Replacement or extension of traditional radio solutions"],
          cta: "Check communication solution",
        },
        {
          key: "private-5g",
          title: "Private 5G gateway for hazardous zones",
          text: "EdgeOne can be used as an industrial access point for public or private 5G and bring connectivity to areas where standard network coverage or Wi-Fi is not sufficient.",
          typical: ["Private 5G campus networks", "Refineries, chemical plants and tank farms", "Temporary connectivity in hard-to-reach areas", "Connection of field devices, sensors and wearables"],
          cta: "Check 5G use case",
        },
        {
          key: "connected-worker-safety",
          title: "Connected Worker Safety with EdgeOne & EdgeWatch",
          text: "EdgeOne can connect workers, wearables and safety functions. Optionally, EdgeWatch can be integrated into a Connected Worker monitoring setup to make vital data, SpO2, activity levels, fall or man-down events, GPS position, noise levels and alerts visible.",
          typical: ["Man-down detection", "Worker localization", "Noise and safety monitoring", "Wearable integration", "Geo-fencing for hazardous areas", "Support for lone work and emergency scenarios"],
          cta: "Request safety pilot",
        },
        {
          key: "iot",
          title: "IoT data collection from sensors and machines",
          text: "EdgeOne can act as an interface between field sensors, machines, tools and higher-level systems. Data such as vibration, noise, temperature, movement or location can be collected and processed.",
          typical: ["Condition monitoring", "Plant monitoring", "Sensor data aggregation", "Foundation for predictive maintenance scenarios"],
          cta: "Discuss IoT pilot",
        },
        {
          key: "ai-knowledge",
          title: "AI knowledge database for technicians",
          text: "Manuals, maintenance documents, process information and technical documents can be prepared for AI-powered knowledge access. Technicians can query information by voice and access relevant knowledge faster.",
          typical: ["Access to maintenance instructions", "Support for fault diagnosis", "Knowledge transfer to new employees", "Reduction of paper documents in the field"],
          cta: "Test AI knowledge access",
        },
        {
          key: "voice-docs",
          title: "Smart Forms / voice documentation",
          text: "Instead of filling out forms manually after the job, the technician can document the work using natural speech. The Smart Forms agent interprets the information, supports structured form completion and can prompt for missing required information.",
          typical: ["Maintenance reports", "Inspection protocols", "Safety permits", "Lockout / Tagout documentation", "Incident and near-miss reports", "Service reports"],
          cta: "Test Smart Forms",
        },
      ],
    },
    industries: {
      label: "TARGET INDUSTRIES",
      headline: "For industrial environments where standard hardware reaches its limits.",
      intro:
        "EdgeOne is especially suitable for companies where connectivity, safety, rugged hardware, remote support and data access in the field are business-critical.",
      cards: [
        { title: "Oil & Gas", text: "For offshore platforms, production facilities, pipelines, refineries and remote sites where rugged connectivity, safety and Remote Assist are critical." },
        { title: "Chemical industry", text: "For hazardous production areas where safe communication, sensor integration, documentation and worker support are required." },
        { title: "Refineries", text: "For complex plants with steel, piping, tanks and difficult wireless coverage — ideal for Remote Assist, Private 5G and Connected Worker." },
        { title: "Energy", text: "For energy providers, power plants, infrastructure operators and technical teams that need rugged connectivity and digital support in the field." },
        { title: "Pharma / process industry", text: "For regulated environments with high requirements for process safety, documentation, quality control and technical support." },
        { title: "Tank farms", text: "For hazardous storage and transfer areas where reliable communication, tracking, safety and monitoring play a central role." },
        { title: "Industrial plants & maintenance", text: "For operators of large production and maintenance environments where sensor data, Remote Assist and digital workflows need to be connected." },
        { title: "Private 5G campus networks", text: "For companies and integrators that want to connect industrial 5G applications with real field processes, devices, sensors and workers." },
      ],
    },
    pilot: {
      label: "YOUR ENTRY POINT",
      teaserHeadline: "Your entry point: RuggedEdge pilot project",
      teaserText: "Review the use case, test the devices, validate the value in the field. ALEGER GLOBAL supports you from the first workshop to practical field testing.",
      teaserCta: "Request pilot project",
      headline: "RuggedEdge pilot project for industrial & ATEX environments",
      intro:
        "The most effective entry point is not a simple device purchase, but a clearly defined pilot project. Together, we evaluate which use case delivers the highest value in your environment — and test EdgeOne with your real requirements.",
      sub:
        "From use-case workshop to field testing: ALEGER GLOBAL supports you from the initial idea to practical validation in the field.",
      includesLabel: "Pilot project includes",
      includes: [
        "Use-case workshop with ALEGER GLOBAL",
        "Selection of the right pilot scenario",
        "EdgeOne devices for testing or pilot operation",
        "Accessories as required, such as headsets, batteries and charging solutions",
        "technical alignment on ATEX, network, location and operating environment",
        "configuration of devices and applications",
        "optional: AI / document integration for maintenance knowledge and process information",
        "support for Remote Assist, Push-to-Talk, IoT data or Connected Worker Safety",
        "training, support and joint evaluation",
      ],
      cta: "Request pilot project",
    },
    specs: {
      label: "TECHNICAL DATA",
      headline: "EdgeOne — compact overview",
      intro:
        "The most important technical specifications at a glance. We will be happy to review further details in the context of your specific application.",
      rows: [
        { k: "Certification", v: "ATEX Zone 1, Class 1 Division 1, intrinsically safe for hazardous areas" },
        { k: "Connectivity", v: "Public / Private 5G, Wi-Fi 6, Wi-Fi 6E, Bluetooth 5.2, NFC" },
        { k: "Operating system", v: "Enterprise Android OS" },
        { k: "Processor", v: "Qualcomm QCM6490, Kryo 670 CPU technology with AI engine" },
        { k: "Memory", v: "4 GB RAM, 64 GB internal storage" },
        { k: "Battery", v: "4209 mAh, replaceable" },
        { k: "Ruggedness", v: "IP68, MIL-STD 810H" },
        { k: "Operating temperature", v: "−20 °C to +60 °C" },
        { k: "Location", v: "GPS, A-GPS, Galileo, Glonass, Beidou" },
        { k: "Sensors", v: "Accelerometer, Gyroscope, Magnetic, Barometer" },
        { k: "SIM", v: "Nano-SIM and eSIM" },
      ],
      cta: "View technical details",
    },
    why: {
      label: "WHY ALEGER GLOBAL?",
      headline: "Your partner for consulting, pilot projects and industrial project business.",
      intro:
        "A solution like RuggedEdge is not simply sold as hardware. The right use case, technical integration, field acceptance and a realistic path from pilot to rollout are decisive. This is where ALEGER GLOBAL supports you.",
      positioning:
        "ALEGER GLOBAL translates RuggedEdge technology into real industrial projects — from the first use-case idea to pilot operation and rollout.",
      cards: [
        { title: "Consulting on the right use case", text: "Together, we evaluate which use case makes sense for your environment: Remote Assist, Push-to-Talk, Private 5G, IoT data, Connected Worker Safety or AI-powered knowledge access." },
        { title: "Hardware procurement and accessories", text: "ALEGER GLOBAL supports selection, procurement and configuration of devices, accessories, batteries, headsets and complementary rugged / ATEX hardware." },
        { title: "Pilot project setup", text: "We structure the entry point as a pilot project: objectives, devices, location, technical requirements, test setup, evaluation and next step." },
        { title: "Integration with partners and system integrators", text: "We work with integrators, telecommunications partners, Private 5G project teams and IT / OT environments to embed RuggedEdge meaningfully into existing projects." },
        { title: "ATEX and rugged hardware experience", text: "ALEGER GLOBAL understands the requirements of industrial special hardware, hazardous areas and rugged mobile devices." },
        { title: "Contact partner in DACH", text: "Customers and partners receive an accessible contact person for consulting, quotation, project clarification, pilot projects and rollout in Germany, Austria and Switzerland." },
        { title: "Project business instead of pure product sales", text: "Our focus is not on quick device sales, but on robust industrial solutions that work in the field." },
      ],
      cta: "Talk to ALEGER GLOBAL",
    },
    faq: {
      label: "FAQ",
      headline: "Frequently asked questions",
      items: [
        { q: "Is EdgeOne suitable for hazardous areas?", a: "EdgeOne is positioned for ATEX Zone 1 environments and Class 1 Division 1. We review the specific suitability for your site together based on your operating conditions and requirements." },
        { q: "Which networks does EdgeOne support?", a: "EdgeOne supports public and private 5G, Wi-Fi 6/6E, Bluetooth 5.2 and NFC. This allows the device to connect to mobile networks as well as local field devices, sensors and wearables." },
        { q: "Can EdgeOne be used for Remote Assist?", a: "Yes. EdgeOne can support Remote Assist applications such as video, audio, collaboration and expert support in the field. The specific implementation depends on use case, network and accessories." },
        { q: "Can EdgeOne collect sensor and machine data?", a: "EdgeOne can be used as an interface for sensors, wearables, smart tools and field devices. Which data is collected and integrated will be reviewed in the project based on your plant and system environment." },
        { q: "How does AI-powered knowledge access work?", a: "Selected documents, manuals, maintenance information or process data can be prepared for AI-powered knowledge access. Depending on the setup, the solution can be implemented locally, on-premise or in the cloud." },
        { q: "Why should I not simply buy a device?", a: "The greatest value is created when EdgeOne is embedded into a specific use case. That is why ALEGER GLOBAL recommends starting with a pilot project with a clear objective, technical alignment and joint evaluation." },
        { q: "Does ALEGER GLOBAL provide support in DACH?", a: "Yes. ALEGER GLOBAL supports customers and partners in Germany, Austria and Switzerland with consulting, pilot projects, procurement and project implementation." },
        { q: "What does a pilot project cost?", a: "The costs depend on use case, number of devices, accessories, integration effort and desired project scope. After a short initial alignment, we will prepare a suitable offer." },
      ],
    },
    contact: {
      label: "CONTACT",
      headline: "Let us review your use case.",
      intro:
        "Would you like to find out whether RuggedEdge is suitable for your plant, your 5G project or your maintenance processes? Briefly describe your application — ALEGER GLOBAL will propose a suitable pilot setup.",
      cta: "Request demo / pilot project",
      info: {
        emailLabel: "Email",
        phoneLabel: "Phone",
        hqLabel: "HQ",
        hq: "Ebensee, Austria",
      },
      form: {
        name: "First and last name",
        email: "Email",
        company: "Company",
        phone: "Phone",
        industry: "Industry",
        useCase: "Desired use case",
        message: "Your application & request",
        placeholder: "Number of devices, location, ATEX requirement, desired use case, existing network infrastructure …",
        consent: "By submitting, you agree to our privacy policy.",
        submit: "Request consultation",
        sending: "Sending …",
        successTitle: "Message received",
        successText: "An ALEGER GLOBAL specialist will contact you within one business day.",
        successAnother: "Send another inquiry →",
        errEmpty: "Please fill in the required fields",
        errGeneric: "Could not send. Please try again.",
        thankYou: "Thanks — we will be in touch within one business day.",
        industryPlaceholder: "Please select",
        usecasePlaceholder: "Please select",
      },
    },
    footer: {
      about:
        "ALEGER GLOBAL GmbH — consulting, pilot projects and distribution of RuggedEdge solutions for industrial 5G, ATEX, Connected Worker and Edge AI applications.",
      cols: [
        { title: "SOLUTIONS", items: ["Remote Assist", "Push-to-Talk", "Private 5G Gateway", "Connected Worker Safety", "IoT Data Collection", "AI Knowledge Database"] },
        { title: "INDUSTRIES", items: ["Oil & Gas", "Chemical Industry", "Refineries", "Energy", "Pharma", "Tank Farms", "Private 5G Campus Networks"] },
        { title: "PRODUCT", items: ["EdgeOne", "Technical Data", "Pilot Project", "Contact"] },
        { title: "CONTACT", items: ["Ischlerstrasse 22, 4802 Ebensee, Austria", "+43 7612 219 6010", "info@alegerglobal.com"] },
      ],
      rights: "All rights reserved. RuggedEdge® and EdgeOne™ are trademarks of RuggedEdge, Inc.",
      legal: { imprint: "Imprint", privacy: "Privacy", terms: "Terms" },
    },
    edgeOnePage: {
      back: "Back to home",
      eyebrow: "Flagship device",
      h1: "EdgeOne™",
      sub: "Purpose-built industrial edge-computing IIoT hub. Reliable & rugged. Scalable & secure.",
      intro:
        "EdgeOne from RuggedEdge is an industrial 5G IIoT edge hub for ATEX Zone 1 environments. The device connects workers, sensors, machines and experts via public and private 5G, Wi-Fi 6/6E, Bluetooth and NFC, and supports Remote Assist, Push-to-Talk, Connected Worker Safety, sensor and machine data capture as well as AI-powered knowledge access. The following specifications provide an overview of hardware, connectivity, certifications and supported ecosystem for use in Oil & Gas, chemical industry, refineries, energy and industrial maintenance.",
      metaTitle: "EdgeOne — ATEX 5G Edge Gateway | ALEGER GLOBAL",
      metaDescription:
        "Technical data and supported ecosystem for the RuggedEdge EdgeOne ATEX 5G edge gateway. Intrinsically safe for ATEX Zone 1, IP68, MIL-STD 810H, public/private 5G, Wi-Fi 6/6E and Enterprise Android.",
      badges: ["ATEX Zone 1", "Class 1 Div 1", "IP68", "MIL-STD 810H", "5G", "Wi-Fi 6E"],
      ctaQuote: "Request a quote",
      specsHeading: "Full specifications",
      ecosystemHeading: "Supported ecosystem",
      ecosystemIntro: "EdgeOne acts as a connectivity hub for your existing field instruments and wearables.",
      quoteHeading: "Request your EdgeOne quote",
      quoteIntro: "Tell us about your sites and target fleet. ALEGER will reply within one business day.",
      fullSpecs: [
        { group: "Processor & Memory", items: [["CPU", "Qualcomm QCM6490 · Kryo 670 · 6th-gen AI engine"], ["RAM", "4 GB"], ["Storage", "64 GB internal"], ["Operating system", "Enterprise Android"]] },
        { group: "Display & Body", items: [["Display", '2.4" FHD touch · 240×320 · Gorilla Glass'], ["Dimensions", '4.91" × 2.55" × 1.46" (125 × 65 × 37 mm)'], ["Weight", "320 g (11.3 oz)"], ["Battery", "4209 mAh · replaceable"]] },
        { group: "Connectivity", items: [["5G", "n1/n2/n3/n5/n7/n8/n12/n20/n25/n28/n38/n40/n41/n48/n65/n71/n77/n78/n79"], ["4G FDD", "1,2,3,4,5,7,8,12,13,14,17,20,25,26,28,29,30,66,71"], ["4G TDD", "38,39,40,41,42,43,48"], ["Wi-Fi", "Wi-Fi 6 & Wi-Fi 6E · 802.11 a/b/g/n/ac/ax/e/k/r/v"], ["Bluetooth", "BT 5.2"], ["NFC / SIM", "NFC · Nano SIM + eSIM"], ["Hotspot", "Up to 32 users"]] },
        { group: "Sensors & GPS", items: [["Sensors", "Accelerometer · Gyroscope · Magnetometer · Barometer"], ["GNSS", "GPS · A-GPS · Galileo · Glonass · Beidou"]] },
        { group: "Certifications", items: [["Hazardous areas", "Class 1 Division 1 · ATEX Zone 1 · Intrinsically safe"], ["Ingress protection", "IP68 (Dust / Water)"], ["Military standard", "MIL-STD 810H"], ["Operating temperature", "-20 °C to +60 °C"]] },
      ],
      peripherals: [
        "Wearable Computing", "Gas Sensors", "Temperature Meters", "Smart Tools",
        "Ultrasonic Probes", "Electronic Meters", "High-Res & IR Cameras", "Health Monitors",
        "Hearing Protection", "Land Mobile Radios", "Pressure Calibrators", "Scanners",
        "PPE Tracking & Compliance", "Asset Tracking & Maintenance",
      ],
    },
    useCasePage: {
      back: "All use cases",
      eyebrow: "Use case",
      ctaQuote: "Discuss this use case",
      problemLabel: "The problem",
      problemHeading: "Why this hurts today.",
      solutionLabel: "The solution",
      solutionHeading: "How EdgeOne makes the difference.",
      benefitsLabel: "Your value",
      benefitsHeading: "Measurable. From day one.",
      workflowLabel: "How rollout works",
      workflowHeading: "From concept to production.",
      quoteHeading: "Test this use case on your site.",
      quoteIntro: "Briefly tell us where you would deploy this use case. We will reply within one business day.",
      relatedLabel: "More use cases",
      relatedHeading: "You might also be interested in.",
      relatedMore: "Read more",
    },
  },
};
